
import type { Dispatch } from 'redux';

import { openDialog } from '../base/dialog';
import { createAndAddInitialAVTracks } from '../base/tracks/mhActions.web';
import { AlertBox } from '../toolbox/components/web/AlertBox';

import { COLOR_PICKER, CONFERENCE_SUBJECT, CONFERENCE_VIEW, POLLS_TAB_FOCUSED } from './actionTypes';

export * from './actions.any';

export {
    filmStripViewStateHandler,
    mapStateToProps,
    getStoredFilmStripView,
    getRecorderOrStoredFilmStripView,
    getSharingTargetFilmstripView,
    exitTileViewIfNeeded,
    handlePinParticipantFilmstrip,
    handleRecorderViewSetup,
    handlePipFilmstripTransition,
    handleResponsiveLayoutCheck,
    handleParticipantCountFilmstrip,
    handleIframeSharingStartFilmstrip,
    handleScreenSharingStartFilmstrip,
    handleIframeSharingStopFilmstrip,
    handleScreenSharingStopFilmstrip,
    handleSelectLayout,
    handleToggleStageView,
    handleToolboxResponsiveFilmstrip,
    handleWhiteboardOrEtherpadOpen,
    handleSharedVideoStart,
    handleSharedVideoPlayerReady
} from './filmStripViewManager';

/**
 * Notify that we've been kicked out of the conference.
 *
 * @param {MHParticipant} participant - The {@link MHParticipant}
 * instance which initiated the kick event.
 * @param {?Function} submit - Callback used to complete teardown after kick.
 * @param {?string} reason - Reson for removing the user.
 * @returns {Function}
 */
export function notifyKickedOut(participant: Object, submit: ?Function, reason: ?string = undefined) {
    return (dispatch: Dispatch<any>) => {

        dispatch(openDialog(AlertBox, {
            alertText: reason ? reason : 'dialog.kickMessage',
            disableOverlay: true,
            submitDisabled: true,
            cancelDisabled: true,
            titleKey: 'dialog.meetingEnd',
            onSubmit: submit
        }));

    };
}

/**
 * Set the value of _isPollsTabFocused.
 *
 * @param {boolean} isPollsTabFocused - The new value for _isPollsTabFocused.
 * @returns {Function}
 */
export function pollsTabFocusedHandler(value) {
    return {
        type: POLLS_TAB_FOCUSED,
        value
    };
}

/**
 * Set the value of _conferenceSubject.
 *
 * @param {string} value - The new value for _conferenceSubject.
 * @returns {Function}
 */
export function conferenceSubjectHandler(value) {
    return {
        type: CONFERENCE_SUBJECT,
        value
    };
}

/**
 * Set the value of _conferenceView.
 *
 * @param {string} value - The new value for _conferenceView.
 * @returns {Function}
 */
export function conferenceViewHandler(value) {

    return {
        type: CONFERENCE_VIEW,
        value
    };
}

/**
 * Set the value of _colorPicker.
 *
 * @param {string} value - The new value for _colorPicker.
 * @returns {Function}
 */
export function colorPickerHandler(value) {
    return {
        type: COLOR_PICKER,
        value
    };
}


/**
 * Starts audio and/or video for the visitor.
 *
 * @param {Array<MediaType>} media - The media types that need to be started.
 * @returns {Function}
 */
export function setupVisitorStartupMedia(media) {
    return dispatch => {
        // Clear the gum pending state in case we have set it to pending since we are starting the
        // conference without tracks.
        dispatch(gumPending([ MEDIA_TYPE.AUDIO, MEDIA_TYPE.VIDEO ], IGUMPendingState.NONE));

        if (media && Array.isArray(media) && media.length > 0) {
            dispatch(createAndAddInitialAVTracks(media));
        }
    };
}
